import { UserViewModel } from "@/models/ViewModels/UserModel";
import BankDetails from "../BankDetails";
import PaymentSourceModel from "./PaymentSourceModel";
import {
  DonorTypeEnum,
  PaymentFrequencyEnum,
  UserCategoryEnum,
} from "@/shared/ModelEnums";
import SchoolAddressModel from "./SchoolAddressModel";

class DonorViewModel extends UserViewModel {
  donorTypeCd: DonorTypeEnum = DonorTypeEnum.DT_P;

  paymentFrequencyCd: PaymentFrequencyEnum = PaymentFrequencyEnum.PF_M;
  donationStatusCd: string = "";
  recognisedSchool: RecognisedSchoolModel;
  reference: string = "";
  paymentProviderReference: string = "";
  emailDonationReceiptsInd: boolean = false;
  creditCardExpiryLastSentDt?: Date;
  donationAmt: number = 0;
  yearOfLastTaxReceipt: number = 0;

  donorCreditCardToken?: string;
  donorBankAccount?: BankDetails;

  donationStatusChangeReason: string = "";
  donationStartDt: Date = new Date();

  paymentSource?: PaymentSourceModel = new PaymentSourceModel();

  currentPaymentSource?: PaymentSourceModel;

  // addressLine1: string = "";
  // addressLine2?: string;
  // addressSuburb: string = "";
  // addressPostcode: string = "";
  australianStateCd: string;
  // addressCountry: string = "Australia";

  donationStatusHistory: DonationStatusHistoryEntryModel[] = [];

  // Recognised student details
  recognisedStudentName: string = "";
  recognisedStudentClassOrYear: string = "";

  constructor() {
    super();
    this.recognisedSchool = new RecognisedSchoolModel();
    this.australianStateCd = "ACT";

    this.userCategoryCd = UserCategoryEnum.UC_D; // Donor
  }
}

export class PrivateDonorViewModel extends DonorViewModel {
  constructor() {
    super();
    // this.recognisedSchoolId = 0;
    this.donationAmt = 0;
    this.donorTypeCd = DonorTypeEnum.DT_P;
  }
}

export class BusinessDonorViewModel extends DonorViewModel {
  businessSizeBracketCd: string;
  businessName: string;
  constructor() {
    super();
    this.businessSizeBracketCd = "BSB_1";
    this.donorTypeCd = DonorTypeEnum.DT_B;
    this.businessName = "";
  }
}

class RecognisedSchoolModel {
  reference: string = "";
  name: string = "";
  // australianStateCd: string = "ACT";
  // suburbOrCity: string = "";
  // postcode: string = "";
  studentsNum: number = 0;
  acaraId?: number;
  schoolAddresses: SchoolAddressModel[] = [];
}

class DonationStatusHistoryEntryModel {
  donationStatusCd: string = "";
  statusText: string = "";
  reason: string = "";
  status: string = "";
}
